<template>
  <div>
    <div class="title">
      <van-icon name="arrow-left" class="lefticon" @click="goBack()" />
      <p>我的卡券</p>
    </div>
    <div>
      <van-tabs v-model="active">
        <van-tab title="未使用">
          <van-empty description="暂无卡券" v-if="!list.length" />
          <template v-else>
            <div class="box" v-for="(item, index) in list" :key="index">
              <div class="vipbox_top">
                <div class="top_line">
                  <div>有效期至：{{ item.enable_date }}</div>
                  <div>
                    适用系统：{{ item.category ? item.category.name : "不限" }}
                  </div>
                  <div>卡券编号：{{ item.code }}</div>
                </div>
                <div v-if="item.type == 'fixed'">
                  <span style="font-size: 0.3rem; font-weight: bold">￥</span>
                  <span style="font-size: 0.5rem; font-weight: bold">{{
                    item.value
                  }}</span>
                </div>
                <div v-else>
                  <span style="font-size: 0.5rem; font-weight: bold">{{
                    item.description
                  }}</span>
                </div>
              </div>
              <div class="vipbox_btm">
                <van-icon name="info-o" size="45rpx;" />
                <div style="padding-left: 7px">{{ item.description }}</div>
              </div>
            </div>
          </template>
        </van-tab>
        <van-tab title="已过期">
          <van-empty description="暂无卡券" v-if="!guoqilist.length" />
          <template v-else>
            <div class="box" v-for="(item, index) in guoqilist" :key="index">
              <div class="vipbox_top">
                <div class="top_line">
                  <div>有效期至：{{ item.enable_date }}</div>
                  <div>
                    适用系统：{{ item.category ? item.category.name : "不限" }}
                  </div>
                  <div>卡券编号：{{ item.code }}</div>
                </div>
                <div v-if="item.type == 'fixed'">
                  <span style="font-size: 0.3rem; font-weight: bold">￥</span>
                  <span style="font-size: 0.5rem; font-weight: bold">{{
                    item.value
                  }}</span>
                </div>
                <div v-else>
                  <span style="font-size: 0.5rem; font-weight: bold">{{
                    item.description
                  }}</span>
                </div>
              </div>
              <div class="vipbox_btm">
                <van-icon name="info-o" size="45rpx;" />
                <div style="padding-left: 7px">{{ item.description }}</div>
              </div>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      list: [],
      guoqilist: [],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    findUserInfo() {
      this.$http.getUserInfo().then((res) => {
        let data = JSON.stringify(res.data);
        window.sessionStorage.setItem("user", data); //存登陆状态
        this.list = res.data.coupon_codes;
        console.log(this.list, "fsda");
        this.guoqilist = this.list.filter((item) => {
          return item.is_enable;
        });
      });
    },
  },
  created() {
    this.findUserInfo();
  },
};
</script>

<style>
.title {
  display: flex;
  background: #228ef7;
}
.lefticon {
  line-height: 0.8rem;
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.4rem;
}
.title p {
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  flex: 0.85;
}
.vipbox_top {
  font-size: 0.29rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.13rem 0.3rem;
}
.top_line div {
  line-height: 1.7;
}
.vipbox_btm {
  border-top: 1px solid #f5f5f5;
  color: #a9a9a9;
  display: flex;
  font-size: 0.3rem;
  align-items: center;
  padding: 0.13rem 0.3rem;
}
.box {
  background: #fff;
  margin-top: 7px;
}
</style>